let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bpQ4j")).then(() => parcelRequire('opv3S'));